import { useState } from 'react';
import { hotList } from '../../../mocks/guaData';

export default function Hero() {
  const [query, setQuery] = useState('');
  const tags = ['人设崩塌', '直播翻车', '综艺对线', '炫富打假', '滤镜事故', '导师翻车'];

  function onSearch(e: React.FormEvent) {
    e.preventDefault();
    if (query.trim()) {
      window.scrollTo({ top: document.getElementById('feeds')?.offsetTop ?? 0, behavior: 'smooth' });
    }
  }

  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      <div className="dot-bg absolute inset-0" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -right-20 top-40 h-72 w-72 rounded-full bg-accent-200/60 blur-3xl" aria-hidden="true"></div>

      <div className="relative mx-auto max-w-7xl px-4 pb-12 pt-28 md:px-6 md:pb-16 md:pt-36">
        <div className="grid items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-primary-700">
              <i className="ri-flashlight-fill text-sm" aria-hidden="true"></i>
              今日吃瓜 · 持续更新
            </p>
            <h2 className="mt-6 font-black leading-tight tracking-tight text-foreground-950 text-4xl md:text-6xl">
              反差吃瓜<span className="text-primary-600">事件合集</span>入口
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
              热门反差名场面、爆点热闻一网打尽。想快速看完当天值得吃的瓜，点这里就够了，
              <strong className="font-bold text-primary-700">收藏入口不迷路</strong>。
            </p>

            <form onSubmit={onSearch} className="mt-7 flex max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
              <label htmlFor="gua-search" className="sr-only">
                搜索吃瓜热闻
              </label>
              <div className="relative flex-1">
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400" aria-hidden="true"></i>
                <input
                  id="gua-search"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="搜一搜最近在吃什么瓜…"
                  className="w-full rounded-full border border-background-300 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
              </div>
              <button
                type="submit"
                className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600"
              >
                开始吃瓜
              </button>
            </form>

            <div className="mt-6 flex flex-wrap items-center gap-2">
              <span className="text-xs font-semibold text-foreground-500">大家都在看：</span>
              {tags.map((t) => (
                <button
                  key={t}
                  type="button"
                  onClick={() => document.getElementById('feeds')?.scrollIntoView({ behavior: 'smooth' })}
                  className="cursor-pointer rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-700 ring-1 ring-background-200 transition hover:bg-accent-100 hover:text-accent-800"
                >
                  #{t}
                </button>
              ))}
            </div>

            <dl className="mt-8 flex flex-wrap gap-8 border-t border-background-200 pt-6">
              <div>
                <dt className="text-xs text-foreground-500">今日更新瓜数</dt>
                <dd className="mt-1 font-black text-2xl text-primary-600">38<span className="text-sm font-bold text-foreground-400">+</span></dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-500">累计名场面</dt>
                <dd className="mt-1 font-black text-2xl text-accent-600">1,286<span className="text-sm font-bold text-foreground-400">+</span></dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-500">每周盘点</dt>
                <dd className="mt-1 font-black text-2xl text-secondary-700">每周五</dd>
              </div>
            </dl>
          </div>

          <div className="lg:col-span-5">
            <aside className="rounded-2xl border border-background-200 bg-background-50 p-5 shadow-soft">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-bold text-foreground-950">
                  <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
                  热榜抢先看
                </h3>
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">实时</span>
              </div>
              <ul className="mt-4 flex flex-col gap-3">
                {hotList.slice(0, 5).map((it) => (
                  <li key={it.rank}>
                    <a href="#hot" className="group flex items-start gap-3 rounded-xl p-2 transition hover:bg-background-100">
                      <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-black ${
                        it.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}>{it.rank}</span>
                      <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 group-hover:text-primary-700">
                        {it.title}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
              <a href="#hot" className="mt-3 flex items-center justify-center gap-1 rounded-xl bg-primary-50 py-2.5 text-sm font-bold text-primary-700 transition hover:bg-primary-100">
                查看完整热榜
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}